export default {
	'132': '#afafaf', // Sdružení ANEO
	'431': '#afafaf', // Sdružení ANEO, NK
	'532': '#00b1a6', // Sdružení ANO 2011, NK
	'768': '#354497', // ANO 2011
	'1071': '#00b1a6', // Koalice VpMB a ANO 2011
	'76': '#afafaf', // Československá strana socialistická
	'7': '#fd751d', // Česká strana sociálně demokratická
	'221': '#fd751c', // Koalice ČSNS, ČSSD
	'230': '#fd751c', // Koalice ČSSD, SŽJ
	'231': '#fd751c', // Koalice ČSSD, KSČM
	'232': '#fd751c', // Koalice ČSSD, ODS
	'233': '#fd751c', // Koalice ČSSD, SDS
	'234': '#fd751c', // Koalice ČSSD, HSMSMNSJ
	'235': '#fd751c', // Koalice ČSSD, SV
	'368': '#fd751c', // Sdružení ČSSD, SPR-RSČ, HSMSMNSJ, NK
	'369': '#fd751c', // Sdružení ČSSD, SŽJ, NK
	'370': '#fd751c', // Sdružení ČSSD, SDS, NK
	'371': '#fd751c', // Sdružení ČSSD, NK
	'429': '#fd751c', // Sdružení ČSSD, US-DEU, NK
	'474': '#fd751c', // Sdružení ČSSD, KSČM, NK
	'573': '#fd751c', // Sdružení ČSSD, SPO, NK
	'624': '#fd751c', // Koalice ČSSD, ČSNS2005
	'682': '#fd751c', // Koalice ČSSD a SPOZ
	'156': '#b51111', // Dělnická strana sociální spravedlnosti
	'575': '#b51111', // Koalice DSSS a SPE
	'600': '#b51111', // Koalice DSSS a SPE
	'192': '#9a7cb6', // HLAVU VZHŮRU - volební blok
	'40': '#90a133', // Klub angažovaných nestraníků
	'382': '#90a133', // Sdružení KAN, NK
	'55': '#c2a8d9', // Koruna Česká (monarch.str.Čech, Moravy a Slezska)
	'1': '#e1be00', // Křesťan.a demokrat.unie-Českosl.strana lidová
	'201': '#e0be00', // Koalice KDU-ČSL, ČSNS
	'204': '#e0be00', // Koalice KDU-ČSL, SZ, NEZ
	'209': '#e0be00', // Koalice KDU-ČSL, KSČM
	// za zadost Stehlik = ODS aby zesedl
	//'210': '#e0be00', // Koalice KDU-ČSL, ODS
	'214': '#e0be00', // Koalice KDU-ČSL, HSMSMNSJ
	'215': '#e0be00', // Koalice KDU-ČSL, NEZ
	'217': '#e0be00', // Koalice KDU-ČSL, SOS
	'279': '#e0be00', // Koalice KDU-ČSL, ČSSD
	'280': '#e0be00', // Koalice KDU-ČSL, SNK
	'303': '#e0be00', // Koalice KDU-ČSL, SZ
	'306': '#e0be00', // Koalice KDU-ČSL, ODS, ČSSD
	'309': '#e0be00', // Koalice KDU-ČSL, HSMS
	'339': '#e0be00', // Koalice KDU-ČSL, Nestraníci
	'340': '#e0be00', // Koalice KDU-ČSL, "STAN"
	'344': '#e0be00', // Koalice KDU-ČSL, SNK ED, Nestraníci
	'349': '#e0be00', // Koalice KDU-ČSL, VPM
	'351': '#e0be00', // Sdružení KDU-ČSL, ČSNS, NK
	'352': '#e0be00', // Sdružení KDU-ČSL, KSČM, NK
	'353': '#e0be00', // Sdružení KDU-ČSL, ODS, NK
	'355': '#e0be00', // Sdružení KDU-ČSL, NK
	'358': '#e0be00', // Sdružení KDU-ČSL, SKS, NK
	'424': '#e0be00', // Sdružení KDU-ČSL, ČSSD, NK
	'479': '#e0be00', // Sdružení KDU-ČSL, SZ, NK
	'486': '#e0be00', // Sdružení KDU-ČSL, SNK ED, NK
	'505': '#e0be00', // Sdružení KDU-ČSL, Nestran., NK
	'535': '#e0be00', // Sdružení KDU-ČSL, Piráti, LES, NK
	'540': '#e0be00', // Sdružení KDU-ČSL, TOP 09, NK
	'553': '#e0be00', // Sdružení KDU-ČSL, KONS, Rozumní, NK
	'559': '#e0be00', // Sdružení KDU-ČSL, NEZ, NK
	'568': '#e0be00', // Sdružení KDU-ČSL, LES, NK
	'569': '#e0be00', // Sdružení KDU-ČSL, SZ, STAN, NK
	'571': '#e0be00', // Sdružení KDU-ČSL, Piráti, NK
	'572': '#e0be00', // Sdružení KDU-ČSL, ZVUK 12, NK
	'578': '#e0be00', // Koalice KDU-ČSL, SZ, OCJJ
	'585': '#e0be00', // Koalice KDU-ČSL a SsČR
	'591': '#e0be00', // Koalice KDU-ČSL, Nestraníci, SsČR
	'594': '#e0be00', // Koalice KDU-ČSL a NV
	'595': '#e0be00', // Koalice KDU-ČSL, SZ, Piráti
	'599': '#e0be00', // Koalice KDU-ČSL, SZ, HNHRM
	'608': '#e0be00', // Koalice KDU-ČSL, USZ
	'667': '#e0be00', // Koalice KDU-ČSL,SZ,KONS,KAN,Suveren.,ČPS
	'668': '#e0be00', // Koalice KDU-ČSL a HNHRM
	'676': '#e0be00', // Koalice KDU-ČSL, SZ, NEZ a US-DEU
	'683': '#e0be00', // Koalice KDU-ČSL, Suveren. a ČPS
	'688': '#e0be00', // Koalice KDU-ČSL a EDS
	'690': '#e0be00', // Koalice KDU-ČSL a Zelení
	'694': '#e0be00', // Koalice KDU-ČSL a SN
	'699': '#e0be00', // Koalice KDU-ČSL, SZ, ČSSD
	'1050': '#e0be00', // Koalice KDU-ČSL a Z21
	'1058': '#e0be00', // Koalice KDU-ČSL a TOP09
	'1069': '#e0be00', // Koalice KDU-ČSL, SZ, STAN
	'1074': '#e0be00', // Koalice KDU-ČSL, SZ, TOP 09
	'1075': '#e0be00', // Koalice KDU-ČSL a HPP
	'1077': '#e0be00', // Koalice KDU-ČSL, SZ, HNHRM a B10.cz
	'1082': '#e0be00', // Koalice KDU-ČSL a KONS
	'1086': '#e0be00', // Koalice KDU-ČSL a ZVUK 12
	'1091': '#e0be00', // Koalice KDU-ČSL, SZ, Piráti a OCJJ
	'1094': '#e0be00', // Koalice KDU-ČSL a LES
	'1095': '#e0be00', // Koalice KDU-ČSL a PSS
	'1103': '#e0be00', // Koalice KDU-ČSL, SZ, SNK ED
	'1104': '#e0be00', // Koalice KDU-ČSL, IO a STAN
	'1147': '#e0be00', // Koalice KDU-ČSL, SZ, HPP 11, Piráti
	'1156': '#e0be00', // Koalice KDU-ČSL, Piráti, DPD, LES
	'47': '#f00', // Koalice KDU-ČSL, IO a STAN
	'251': '#f00', // Koalice KDU-ČSL, IO a STAN
	'301': '#f00', // Koalice KSČM, SZ
	'385': '#f00', // Sdružení KSČM, SDS, NK
	'386': '#f00', // Sdružení KSČM, SDS, SV, NK
	'387': '#f00', // Sdružení KSČM, NK
	'388': '#f00', // Sdružení KSČM, HSMSMNSJ, NK
	'500': '#f00', // Sdružení KSČM, FiS, NK
	'533': '#f00', // Sdružení KSČM, SPO, NK
	'546': '#dd82a1', // Sdružení LEV 21, NK
	'764': '#dd82a1', // LEV 21 - Národní socialisté
	'762': '#71277a', // OBČANÉ 2011
	'53': '#4a4bfe', // Občanská demokratická strana
	'307': '#4a4aff', // Koalice ODS, SZ
	'389': '#4a4aff', // Sdružení ODS, NK
	'523': '#4a4aff', // Sdružení ODS, TOP 09, NK
	'563': '#4a4aff', // Sdružení ODS, TOP 09, NK
	'617': '#4a4aff', // Koalice ODS, SNK ED
	'1092': '#4a4aff', // Koalice ODS a KČ
	'1101': '#4a4aff', // Koalice ODS a Svobodní
	'1105': '#4a4aff', // Koalice ODS a PSZ
	'1155': '#4a4aff', // Koalice ODS, SNK ED, SsČR, STO
	'1306': '#4a4aff', // Jan Tecl (ODS+STAN+STO)
	'98': '#e310a5', // Volte Pravý Blok www.cibulka.net
	'261': '#e310a5', // Koalice Pravý blok - Klub angažovaných nestraníků
	'541': '#353535', // Sdružení Piráti, NK
	'552': '#808080', // Sdružení Piráti, LES, NK
	'720': '#2f2f2f',	// Česká pirátská strana
	'1060': '#808080', // Koalice Piráti a Změna
	'1066': '#808080', // Koalice Piráti a SZ
	'1109': '#808080', // Sdružení Piráti, Změna, NK
	'794': '#afafaf', // Romská demokratická strana
	'724': '#e95850', // Strana Práv Občanů
	'497': '#cdb649', // Sdružení SsČR, NK
	'716': '#cdb649', // Strana soukromníků České republiky
	'1073': '#cdb649', // Koalice SsČR a PPL
	'493': '#f5a020', // Sdružení Suverenita, NK
	'654': '#f5a020', // Suverenita
	'714': '#2f652f', // Strana svobodných občanů
	'5': '#1acf0e',	// Strana zelených
	'227': '#1acf0f', // Koalice SZ, ČSSD
	'480': '#8c3e62', // Sdružení TOP 09, NK
	'495': '#8c3e62', // Sdružení TOP 09, \"STAN\", NK
	'501': '#8c3e62', // Sdružení TOP 09, SZ, NK
	'513': '#8c3e62', // Sdružení TOP 09, SLK, NK
	'660': '#8c3e62', // Sdružení ODS, TOP 09, NK
	'674': '#8c3e62', // Koalice TOP 09 a Věci veřejné
	'687': '#8c3e62', // Koalice TOP 09 a ODS
	'721': '#8c3f63', // TOP 09
	'1329': '#8c3e62', // Herbert Pavera (ODS+STAN+TOP 09)
	'697': '#8c3e62', // STAROSTOVÉ A NEZÁVISLÍ s podporou TOP 09
	'659': '#8c3e62', // Koalice "STAN" a TOP 09,
	'596': '#8c3e62', // Koalice "STAN" a "HOPB"
	'1164': '#8c3e62', // Koalice STAN, SLK
	'166': '#b6c932', // STAROSTOVÉ A NEZÁVISLÍ
	'554': '#81addd', // Sdružení Úsvit, NK
	'565': '#81addd', // Sdružení Úsvit, VZ, NK
	'792': '#81addd', // Úsvit přímé demokracie
	'1090': '#81addd', // Koalice Úsvit a Hora 2014
	'510': '#c4a99d', // Sdružení změna, NK
	'703': '#99C7C7', // SLK - Starostové pro Liberecký kraj
	'771': '#c4a99d', // politické hnutí Změna
	'704': '#f5a020', // Severočeši.cz
	'755': '#b9a93b', // Ostravak
	'795': '#AFAFAF', // RDS (Romská demokratická strana)
	'1114': '#D97A78', // SPD (Svoboda a přímá demokracie)
	'1227': '#469288', // Trikolóra
	'1454': '#EFA5EF', // ODS+STAN+VČ
	'1187': '#35A3AE', // SEN 21
	'default': '#888'// zbytek
}
